import { Route, Routes } from 'react-router-dom';
import {
  checksDetailsSubRouteRef,
  checksEditSubRouteRef,
  checksNewSubRouteRef,
} from '../../routes';
import { PulseChecksPage } from './checks-page';
import { PulseChecksDetails } from './checks-details';
import { PulseCheckFormPage } from './create-check';

export const PulseChecksRouting = () => {
  return (
    <Routes>
      <Route path="/" element={<PulseChecksPage />} />
      <Route
        path={checksNewSubRouteRef.path}
        element={<PulseCheckFormPage />}
      />
      <Route
        path={checksEditSubRouteRef.path}
        element={<PulseCheckFormPage />}
      />
      <Route
        path={checksDetailsSubRouteRef.path}
        element={<PulseChecksDetails />}
      />
    </Routes>
  );
};
